import { useEffect } from 'react';
import { UpgradePopup } from '../../../components/elements/UpgradeConfirmModal';
import useFooterMenu from '../../../hooks/useFooterMenu';
import { __ } from '../../../translations';
import useGamification from '../hooks/useGamification';
import useRedeemActions from '../hooks/useRedeemActions';
import { InSufficientPointPopup, QRPopup } from './elements';
import GamificationView from './presentation/GamificationView';

const Redeem = () => {
    // Hooks
    const { termsLink } = useFooterMenu();
    const {
        badges,
        redeemQuests,
        balance,
        activeBadge,
        badgeLoading,
        questsLoading,
        balanceLoading,
        getNotifications,
    } = useGamification();
    const {
        openQRModal,
        qrRewardType,
        isUpgradeModalOpen,
        isInsufficientPopup,
        isInsufficientPopupType,
        requiredPoint,
        showUpgradeRedeemQuest,
        setOpenQRModal,
        handleClickMoviesStore,
        handleClickTierUpgrade,
        upgradeHandler,
        insufficientPointPopupHandler,
        start,
        stop,
    } = useRedeemActions(balance, getNotifications);

    // Effects
    useEffect(() => {
        start();
        return stop;
    }, [start, stop]);
    return (
        <GamificationView
            badgeProps={{ activeBadge, badgeLoading, badges }}
            scoreCardProps={{ activeBadge, balance, badgeLoading, balanceLoading, termsLink }}
            questProps={{
                quests: redeemQuests,
                isLoading: questsLoading,
                buildRewardProps: (quest) => {
                    const isPreview = balance > quest.points;
                    const isTierUpgrade = quest?.id === 'redeem_tier_upgrade';
                    if (isTierUpgrade && !showUpgradeRedeemQuest()) return null;
                    const commonProps = {
                        key: quest.id,
                        heading: __(quest.title),
                    };

                    if (isPreview) {
                        return {
                            ...commonProps,
                            type: 'preview',
                            reward: quest.points,
                            cta: { text: __(quest?.ctaLabel) },
                            ctaLinkOnClick: () =>
                                isTierUpgrade
                                    ? handleClickTierUpgrade(quest?.points)
                                    : handleClickMoviesStore(quest?.points),
                        };
                    }

                    return {
                        ...commonProps,
                        type: 'inProgress',
                        progress: {
                            current: balance,
                            total: quest.points,
                            showInfo: () =>
                                isTierUpgrade
                                    ? handleClickTierUpgrade(quest?.points)
                                    : handleClickMoviesStore(quest?.points),
                        },
                    };
                },
            }}
        >
            <QRPopup openQRModal={openQRModal} setOpenQRModal={setOpenQRModal} rewardType={qrRewardType} />

            {isUpgradeModalOpen && (
                <UpgradePopup
                    isOpen={isUpgradeModalOpen}
                    handleCloseModal={() => upgradeHandler(false)}
                    OnUpgradeClick={() => upgradeHandler(true)}
                />
            )}

            {isInsufficientPopup && (
                <InSufficientPointPopup
                    isOpen={isInsufficientPopup}
                    handleCloseModal={insufficientPointPopupHandler}
                    currentPoint={balance}
                    requiredPoint={requiredPoint}
                    isInsufficientPopupType={isInsufficientPopupType}
                />
            )}
        </GamificationView>
    );
};

export default Redeem;
